import React from "react";
import skyscraper from "@assets/images/skyscraper.jpg";

export default function RightPanel() {
  return (
    <div className="hidden grow md:flex flex-col">
      <section
        className="bg-no-repeat [background-position-x:-690px] flex flex-col flex-grow justify-center items-center text-white"
        style={{
          backgroundImage: `url(${skyscraper})`,
        }}
      >
        <div className="bg-black/70 p-8 flex flex-col gap-10 rounded-lg font-lato font-bold min-w-[350px]">
          <div className="text-6xl uppercase leading-tight">
            <div>
              Agilify<sup className="font-normal ml-2">TM</sup>
            </div>
            <div>LMS</div>
          </div>
          <div className="bg-white w-[72%] h-[13px]"></div>
          <div>
            <p>Welcome to the Henry Schein demo site,</p>
            <p>brought to you by Rarify Learning</p>
          </div>
        </div>
      </section>
      <section className="bg-black text-white text-center text-sm py-3.5">
        <p>
          The information presented on this site is{" "}
          <span className="font-bold">confidential and proprietary</span>.
        </p>
        <p>Please do not share or distribute outside of your organization.</p>
      </section>
    </div>
  );
}
